import * as Pages from "../pages"; 

export const AppRoutes = [
  {
    icon: null,
    title: "teste",
    path: "/",
    component: Pages.HomePage,
  },
];
